module.exports = "<div class=\"header\">\n  <h1 [class.desktop]=\"!isMobile\"><a [href]=\"link\" target=\"_blank\">{{handle}}</a></h1>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/mdg/Source/markclimb/src/app/shared/subhead/subhead.component.html
// module id = ../../../../../src/app/shared/subhead/subhead.component.html
// module chunks = main